import React from 'react';
import type { ICheckboxProps } from './Checkbox.types';
import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';
import cn from 'classnames';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles, getWCAMode } from '@Managers/Redux/AppState/AppState';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES
import switchON from './switch_on.svg';
import switchOFF from './switch_off.svg';
import switchONWCA from './switch_on_wca.svg';
import switchOFFWCA from './switch_off_wca.svg';

const Checkbox: React.FC<ICheckboxProps> = ({ label, checked, onChange, showLabel = true, autoFocus, ariaLabel, labelDirection = 0, id }) => {
    const onClick = () => {
        onChange();
    };

    const wcaMode = useAppSelector(getWCAMode);
    const globalStyles = useAppSelector(getGlobalStyles);

    const icons = {
        on: wcaMode ? switchONWCA : switchON,
        off: wcaMode ? switchOFFWCA : switchOFF
    };

    const checkedIcon = checked ? icons.on : icons.off;

    const labelID = id ? `${id}_label` : '';
    const checkboxID = id ? `${id}_checkbox` : '';

    const checkBox = cn(styles.checkbox_input, globalStyles.device, globalStyles.orientation);
    const checkBoxLeft = cn(styles.checkbox_label, styles.checkbox_label_left, globalStyles.device, globalStyles.orientation);
    const checkBoxRight = cn(styles.checkbox_label, styles.checkbox_label_right, globalStyles.device, globalStyles.orientation);

    return (
        <div className={cn(styles.checkbox_container, !showLabel ? styles.checkbox_without_label : false)}>
            {labelDirection === 0 && (
                <>
                    {label && showLabel && (
                        <div id={labelID} className={checkBoxLeft}>
                            {label}
                        </div>
                    )}
                </>
            )}
            <div
                id={checkboxID}
                role="checkbox"
                tabIndex={0}
                aria-checked={checked}
                className={checkBox}
                onPointerDown={() => onClick()}
                onKeyDown={(e) => KeyboardEventCheck(e as any, onClick)}
                aria-description={`${ariaLabel ? ariaLabel : label}: ${checked}`}
                autoFocus={autoFocus ? true : false}
            >
                <img className={styles.checkbox_image} src={checkedIcon} alt={`Image: ${ariaLabel}: ${checked}`} />
            </div>
            {labelDirection === 1 && <>{label && showLabel && <div className={checkBoxRight}>{label}</div>} </>}
        </div>
    );
};

export default Checkbox;
